// src/modules/perfil-skeleton.js — placeholder del perfil mientras carga el RPC.
//
// FASE perf-perfil (30-may). El perfil colapsó sus ~7 round-trips en 1 RPC
// (perfil_completo). Antes el innerHTML recién aparecía al final del fetch →
// la pantalla anterior quedaba congelada. Ahora pintamos este skeleton ANTES
// del await (igual que la Tribuna en tribuna.js:109), y lo reemplazamos por el
// perfil real cuando resuelve el RPC.
//
// El apodo / avatar / nombre son reales (vienen de profileData = localStorage,
// sin red): el header se pinta de una y solo los datos de red (puntos, history
// cards, arengas guardadas) van como placeholders con pulse.
//
// HTML puro; reusa las clases existentes del perfil (.perfil-v2, .perfil-hero,
// etc.) + variables CSS del theme. Único agregado: el pulse scopeado por
// .perfil-skel-pulse (mismo patrón que rituales-skeleton.js).

export const buildPerfilSkeleton = ({ codigo, apodo, nombre, initials, activeGroupBar = '', bottomNav = '' } = {}) => `
    <style>
        @keyframes perfilSkelPulse { 0%, 100% { opacity: .5; } 50% { opacity: .9; } }
        .perfil-skel-pulse { animation: perfilSkelPulse 1.25s ease-in-out infinite; }
        .perfil-skel-box { border-radius:12px; background:rgba(255,255,255,.06); }
    </style>
    <div class="perfil-v2" data-perfil-skeleton>
        ${activeGroupBar}
        <section class="perfil-hero">
            <div class="perfil-player">
                <div class="perfil-avatar">${initials}</div>
                <div style="min-width:0;flex:1;">
                    <h2 class="perfil-name">${apodo}</h2>
                    ${nombre ? `<p class="perfil-real-name">${nombre}</p>` : ''}
                </div>
                <button class="perfil-whatsapp-btn is-disabled" type="button" disabled aria-disabled="true" title="No disponible todavía">Whatsapp notificaciones<span class="perfil-whatsapp-soon">Próximamente</span></button>
            </div>
        </section>
        <section class="perfil-points" aria-label="Cargando puntos">
            ${[0, 1, 2].map(() => `
                <div class="perfil-point">
                    <span class="perfil-skel-pulse perfil-skel-box" style="display:block;height:1.3rem;width:60%;margin:0 auto .35rem;"></span>
                    <span class="perfil-skel-pulse perfil-skel-box" style="display:block;height:.6rem;width:80%;margin:0 auto;"></span>
                </div>
            `).join('')}
        </section>
        <div class="perfil-skel-pulse perfil-skel-box" style="height:3.1rem;margin:.6rem 0;"></div>
        <div class="perfil-skel-pulse perfil-skel-box" style="height:2.6rem;margin:.6rem 0;"></div>
        <h3 class="perfil-section-title">Mi Historial</h3>
        <section class="perfil-history">
            ${[0, 1, 2].map(() => `
                <article class="perfil-history-card">
                    <div style="flex:1;">
                        <span class="perfil-skel-pulse perfil-skel-box" style="display:block;height:.7rem;width:45%;margin-bottom:.4rem;"></span>
                        <span class="perfil-skel-pulse perfil-skel-box" style="display:block;height:.55rem;width:70%;"></span>
                    </div>
                    <span class="perfil-skel-pulse perfil-skel-box" style="width:2.4rem;height:1rem;"></span>
                </article>
            `).join('')}
        </section>
        <h3 class="perfil-section-title">Arengas guardadas</h3>
        <section class="perfil-arengas-guardadas">
            <div class="perfil-arengas-grid" style="display:grid;grid-template-columns:repeat(2, minmax(0, 1fr));gap:.5rem;">
                ${[0, 1].map(() => `<div class="perfil-skel-pulse perfil-skel-box" style="aspect-ratio:1;"></div>`).join('')}
            </div>
        </section>
    </div>
    ${bottomNav}
`;
